export class CompanyVars {
	ID:number = 0;
	VisitedPricingPage:boolean = false;
	Notes:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.VisitedPricingPage = data.VisitedPricingPage || false;
		this.Notes = data.Notes || "";
	}
}